// import { json } from "react-router-dom"
import { Show } from "@chakra-ui/react";
import ShowData from "../components/ShowData";
import styles from "../styles/Products.module.css"
import { Button, ButtonGroup } from '@chakra-ui/react'
import {  useState } from "react";
import {useSelector} from "react-redux"
import { useToast ,Box} from '@chakra-ui/react'
import styled from "styled-components"
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure
  } from '@chakra-ui/react'
  import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBInput,
    MDBRow,
    MDBTypography,
    } from "mdb-react-ui-kit";
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
  } from '@chakra-ui/react'
function Cart(){

    const toast = useToast()
    const { isOpen, onOpen, onClose } = useDisclosure()

const isAuth = useSelector((state)=> state.authReducer.isAuth) 
    let [data,setdata] = useState(JSON.parse(localStorage.getItem("cartData"))) 
    console.log(data);
    const [total,setTotal] = useState(0)
    const [totalItem,setItem] = useState(0)
    // let total = 0;
    // let totalItem = 0;
    function handlePayment(){
        localStorage.removeItem("cartData");
        setdata(null)
        toast({

            render: () => (
              <Box color='white' p={3} bg='blue.500'>
                Order Placed Successfully
              </Box>
            )
          })
          onClose()

    }
    const handleIncQuantity=(id) =>{
      let newData = data.map((element,i) => {
        if(element.id == id){
          element.quantity++;
          // console.log(data[i]);
          return element;
        }
        else{
          return element;
        }
      });
      setdata(newData)
    }
    const handleDecQuantity=(id) =>{
      let newData = data.map((element,i) => {
        if(element.id == id){
          element.quantity--;
          // console.log(data[i]);
          return element;
        }
        else{
          return element;
        }
      });
      setdata(newData)
    }
    function removeaLL(){
      localStorage.removeItem("cartData");
      setdata(null)
      toast({

          render: () => (
            <Box color='white' p={3} bg='blue.500'>
              Your Cart is Empty!
            </Box>
          )
        })
        onClose()

  }
    if(isAuth){
        return(
            <DIV>
                {
                    <div className={styles.products}>
                    {
                      data ?  data.map((el,index)=>(
                          <div style={{lineHeight:"10px"}} key={index}>
                            <div style={{visibility: "hidden"}}>
                                {setTotal(total+el.price)}
                                { setItem(totalItem+1) }
                            </div>
                                <img src={el.image} alt="" />
                                <h3>{el.title}</h3>
                                <p>{el.description}</p>
                                <p>Rating: {el.rating}</p>
                                <p>Rs. {el.price}</p>
                                <p style={{color:"orange", fontSize:"x-smaller"}}>(53%OFF)</p>
                                <div className="quantityDiv">
                                  <Button  onClick={()=> handleDecQuantity(el.id)}>-</Button>
                                  <p>
                                  {el.quantity}
                                     </p>
                                  <Button onClick={()=> handleIncQuantity(el.id)}>+</Button>
                                </div>

                                 <Button margin="5px" onClick={()=>{
                                    
                                    
                                    setdata(data.filter((element,id)=>{return id !== index}  ))
                                    localStorage.setItem("cartData",JSON.stringify(data))
                                    toast({

                                        render: () => (
                                          <Box color='white' p={3} bg='blue.500'>
                                            Product Removed
                                          </Box>
                                        )
                                      })
                                    // window.location.reload(false);
                                    // setLogin(true)
                                }} colorScheme='blue'>Remove</Button>

                            </div>
                        )) : <h1> Your Cart Is Empty </h1>
                    }
       
    
                </div>
                }

                <div className="buySection">
                    <h2>CART:-</h2>
                    <h3>Total Items: {totalItem} </h3>
                    <h3>Total Price: ₹{total} </h3>
                    <Button className="btn" w={"80%"} m={"auto"} colorScheme="yellow" onClick={onOpen} > Buy</Button>
                    <Button className="btn" w={"80%"} m={"10px auto"}   onClick={removeaLL}>Remove all</Button>
                    <Modal
        isCentered
        onClose={onClose}
        isOpen={isOpen}
        motionPreset='slideInBottom'
      >
        <ModalOverlay />
        <ModalContent>
          {/* <ModalHeader>Modal Title</ModalHeader> */}
          <ModalCloseButton />
          <ModalBody>
          <MDBCol >
                <MDBCard className="bg-primary text-white rounded-3">
                  <MDBCardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <MDBTypography tag="h5" className="mb-0">
                        Card details
                      </MDBTypography>
                     
                    </div>

                    <p className="small">Card type</p>
                   

                    <form className="mt-4">
                      <MDBInput className="mb-4" label="Cardholder's Name" type="text" size="lg"
                        placeholder="Cardholder's Name" contrast />

                      <MDBInput className="mb-4" label="Card Number" type="text" size="lg"
                        minLength="19" maxLength="19" placeholder="1234 5678 9012 3457" contrast />

                      <MDBRow className="mb-4">
                        <MDBCol md="6">
                          <MDBInput className="mb-4" label="Expiration" type="text" size="lg"
                            minLength="7" maxLength="7" placeholder="MM/YYYY" contrast />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput className="mb-4" label="Cvv" type="text" size="lg" minLength="3"
                            maxLength="3" placeholder="&#9679;&#9679;&#9679;" contrast />
                        </MDBCol>
                      </MDBRow>
                    </form>

                    <hr />

                    <div className="d-flex justify-content-between">
                      <p className="mb-2">Subtotal</p>
                      <p className="mb-2">₹{total}</p>
                    </div>

                    <div className="d-flex justify-content-between">
                      <p className="mb-2">Shipping</p>
                      <p className="mb-2">20.00</p>
                    </div>

                    <div className="d-flex justify-content-between">
                      <p className="mb-2">Total(Incl. taxes)</p>
                      <p className="mb-2">₹{total+20}.00</p>
                    </div>

                    <MDBBtn onClick={handlePayment} color="info" block size="lg">
                      <div className="d-flex justify-content-between">
                        
                        <span >
                          Checkout{" "}
                          <i className="fas fa-long-arrow-alt-right ms-2"></i>
                        </span>
                      </div>
                    </MDBBtn>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
          </ModalBody>
          <ModalFooter>
            {/* <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button> */}
            {/* <Button variant='ghost'>Secondary Action</Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
                </div>
            </DIV>
        )
    }
    else{
        return(
            <div>
                <Alert status='error'>
  <AlertIcon />
  <AlertTitle>you're not logged in</AlertTitle>
  <AlertDescription>Please, Click on profile icon to login</AlertDescription>
</Alert>
            </div>
        )
    }
    
}
const DIV = styled.div`
display: flex;
.buySection{
    width:30%;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    padding: 50px 20px;
    line-height: 30px;
    height: fit-content;
    margin : 100px 20px;
}
@media (max-width: 480px) {
  display: flex;
flex-direction: column-reverse;
h3{
  font-size: medium;
}
h2{
  font-size: 20px;
}
.buySection{
    width:fit-content;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    padding: 60px 20px;
    line-height: 30px;
    height: fit-content;
    margin : 60px auto;
}

.btn{
  /* height: 20px; */
  /* font-size: small; */
}

}
.quantityDiv{
  display: flex;

}
.quantityDiv > p {
  margin: 10px 10px;
}
`
export default Cart